import type { ReactNode } from "react";

import { styled } from "simplydo/react/styled";
import { Label } from "simplydo/react/ui/label";

import {
  addressLines,
  companyPlaces,
  isPostcodeOnly,
  POSTCODE_ONLY_EXPLANATION,
} from "components/innointel/Tools/locations";
import type { InnointelCompany } from "components/innointel/types";

import { KeyFact } from "../Styles";
import CompanyMap from "./CompanyMap";

const LocationsLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > .places {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .postcode-only {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-top: 6px;
    font-size: 13px;
    white-space: normal;
    color: #5b6470;
  }
`;

type CompanyLocationsProps = {
  company: InnointelCompany;
  /** Shown under the search location */
  searchNote?: ReactNode;
};

const CompanyLocations = ({ company, searchNote }: CompanyLocationsProps) => {
  const places = companyPlaces(company.location);
  if (!places.length) {
    return null;
  }

  return (
    <LocationsLayout>
      <CompanyMap mapKey={company._id} places={places} />
      <div className="places">
        {places.map((place) => {
          const lines = addressLines(place.address);
          return (
            <KeyFact
              key={place.key}
              title={places.length > 1 ? place.label : "Location"}
              fact={
                <div>
                  {lines.length ? (
                    lines.map((line) => <div key={line}>{line}</div>)
                  ) : (
                    <div>No address yet</div>
                  )}
                  {isPostcodeOnly(place.address) ? (
                    <div className="postcode-only">
                      <Label color="orange" basic size="small">
                        Postcode only
                      </Label>
                      {POSTCODE_ONLY_EXPLANATION}
                    </div>
                  ) : null}
                  {place.key === "search" ? searchNote : null}
                </div>
              }
            />
          );
        })}
      </div>
    </LocationsLayout>
  );
};

export default CompanyLocations;
